export const clearLocalStorage = () => {
  localStorage.removeItem('selectedProduct');
  localStorage.removeItem('clientCategory');
  localStorage.removeItem('email');
  localStorage.removeItem('selectedDate');
  localStorage.removeItem('startDate');
  localStorage.removeItem('operationId');
  localStorage.removeItem('referenceSuccess');
  localStorage.removeItem('retryPayment');
  localStorage.removeItem('successText');
  localStorage.removeItem('paymentDecline');
  localStorage.removeItem('preset');
  localStorage.removeItem('userId');
  localStorage.removeItem('policyCost');
  localStorage.removeItem('petsTemporaryFranchise');
};
